/**
 * 관리자 수발주제한 (/adm/relation) — 회원1·회원2 쌍의 수발주 제한 목록·등록·삭제
 * ($j.Pages.Admin.Relation / body data-page-name="Relation")
 */
export default class Relation {
    initialize() {
        this.$table = null;

        // 입력 필드와 리스트를 제어할 인스턴스 생성
        $j.F.Admin.AutoComplete.init({id: 'find-user-kwd'});
        $j.F.Admin.AutoComplete.init({id: 'register-kwd'});

        $('#find-user-search-btn').on('click', () => this.search());
        $('#relation-btn').on('click', () => this.register());

        this.loadTable();
    }

    /**
     * 데이터 테이블 컬럼
     */
    loadTable() {
        const columns = [
            {data: 'num', title: 'No.'},
            {data: 'mem_name', title: '회원1'},
            {data: 'other_name', title: '회원2'},
            {data: 'reg_date', title: '날짜', render: v => $j.Common.Util.formatDateTime(v)},
            {data: 'manage_name', title: '등록자'},
            {data: 'memo', title: '사유'},
            {data: null, title: '취소', render: () => '삭제'}
        ];

        if (this.$table) {
            this.$table.destroy();
            $('#table').empty();  // 테이블 내용을 비워서 초기화
        }

        const $table = this.$table = new DataTable('#table', {
            autoWidth: false,
            columns: columns,
            // 7번째 칸(삭제) 강조
            rowCallback: (row) => $(row).find('td:nth-child(7)').addClass('cr-bold cr-bold-blue'),
            headerCallback: (thead) => $(thead).find('th').css('text-align', 'center'),
            ajax: {
                url: '/adm/ajax/member/relation',
                type: 'POST',
                data: (d) => {
                    d.findMbNumber = $('#find-user-kwd').data('value')
                },
            },
            processing: true,
            serverSide: true,
            ordering: false,
            displayLength: 20,
            lengthChange: false,
            searching: false
        });
        // 2,3번째 컬럼 클릭시
        $('#table tbody').on('click', 'td:nth-child(2), td:nth-child(3)', function (e) {
            const data = $table.row(this).data();

            $j.F.Admin.Util.memberPortal(data.mb_no);
            e.stopPropagation();//이벤트 전파막기
        });
        // 7번째 컬럼 (삭제) 클릭시
        $('#table tbody').on('click', 'td:nth-child(7)', (e) => {
            const data = $table.row(e.currentTarget).data();
            $j.Common.Util.swalert(["삭제하겠습니까?", 'question'], () => {
                this.doDelete(data);
            }, ['예', '아니오']);
        });
    }

    /**
     * 검색 시 테이블 갱신
     */
    search() {
        this.$table.ajax.reload();
        if ($('#find-user-kwd').data('value')) {
            $('#register-span').removeClass('rel-off');
        } else $j.Common.Util.swalert('목록에서 선택한 회원이 없습니다.')
    }

    /**
     * 수발주 제한 등록
     */
    register() {
        const data = {
            mb_no: $('#find-user-kwd').data('value'),
            other_no: $('#register-kwd').data('value'),
            memo: $('#reason').val()
        }
        $.ajax({
            url: '/adm/ajax/member/relation/add',
            type: 'POST',
            data: data,
            success: (r) => {
                if (r.result) {
                    $j.Common.Util.swalert('등록되었습니다.', () => {
                        this.clear();
                        $('#register-span').addClass('rel-off');
                        this.$table.ajax.reload();
                    });
                } else {
                    $j.Common.Util.swalert('이미 등록되어있거나 오류가 발생했습니다.', () => {
                        this.$table.ajax.reload();
                    });
                }
            }
        })
    }

    /**
     * 수발주제한 항목을 삭제
     * @param data
     */
    doDelete(data) {
        $.ajax({
            url: '/adm/ajax/member/relation/delete',
            type: 'delete',
            data: {num: data.num},
            success: () => {
                $j.Common.Util.swalert('삭제되었습니다.', () => {
                    this.$table.ajax.reload();
                });
            }
        })
    }

    /**
     * 검색창 내용을 삭제
     */
    clear() {
        $('#find-user-kwd').val('').data('value', '');
        $('#register-kwd').val('').data('value', '');
        $('#reason').val('');
    }
}
